/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=f8bfbda4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f8bfbda4&lang=scss"

import exportComponent from "D:\\project\\git\\ValueSwap_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__